export default "__VITE_ASSET__V7s98Vi4__"